import {SentinelLoading} from 'presentation/components/SentinelLoading';
import {useLazyScroll} from 'presentation/hooks/useLazyScroll';
import React, {Fragment, useState} from 'react';

import type {ProvidersMedicalGuide} from 'domain/usecases';

import {StyledContentCards, StyledNetworkTitle} from './styles';
import type {RenderGroupsTypesProps} from './types';
import {useAccountInformation, useQueryParams} from 'presentation/pages/private/hooks';
import {HealthGuideServicesTypeEnum} from 'presentation/constants';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {NetworkAlert} from '../NetworkAlert';
import {HealthGuideCard} from '../HealthGuideCard';
import {HealthGuideDetails} from '../HealthGuideDetails';
import {Box} from '@mui/material';

export function GroupItem({
	isGndiSaoPaulo,
	list = [],
	showTradeNameFlag,
	title,
	type,
}: RenderGroupsTypesProps) {
	const {SEARCH_PARAMS} = useQueryParams();
	const {comingFrom, serviceType} = SEARCH_PARAMS;

	const [openDetails, setOpenDetails] = useState(false);
	const [provider, setProvider] = useState<ProvidersMedicalGuide>();
	const {items, scrollableContentRef, loadingNewPageState, handleVisible} = useLazyScroll({
		itemsList: list,
		itemsPerPage: 16,
		loadingTime: 350,
	});
	const {isEarlyAccess} = useAccountInformation();

	const showNetworkAlert =
		!isEarlyAccess &&
		comingFrom !== FlowEnum.EXAM &&
		serviceType !== HealthGuideServicesTypeEnum.AUXILIARY_SERVICES;

	if (!list.length) return null;

	return (
		<Box>
			<Fragment>
				<StyledNetworkTitle variant="subtitle1">{title}</StyledNetworkTitle>

				{showNetworkAlert ? <NetworkAlert type={type} /> : null}
			</Fragment>

			<StyledContentCards
				ref={scrollableContentRef}
				$isEmpty={false}
				$isGndiSaoPaulo={isGndiSaoPaulo}>
				{items.map((item, index) => (
					<HealthGuideCard
						key={`${item.nmPrestador}-${index}`}
						provider={item}
						showTradeName={showTradeNameFlag}
						handleOpenDetails={() => {
							setProvider(item);
							setOpenDetails(true);
						}}
					/>
				))}
			</StyledContentCards>

			<HealthGuideDetails
				open={openDetails}
				handleClose={() => {
					setOpenDetails(false);
				}}
				provider={provider}
				showTradeName={showTradeNameFlag}
			/>

			<SentinelLoading
				minHeight="200px"
				onVisible={handleVisible}
				isLoading={loadingNewPageState}
			/>
		</Box>
	);
}
